import { widgetFilterSchema } from '../../common/schema'
import { okOrThrow } from '../../common/http'
import { homerunnerApiBaseUrl } from '../../hr'
import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

export const descriptionParamsSchema = widgetFilterSchema.extend({
  feed_id: z.number().int().describe('Filter by feed ID'),
  platform: z.string().nullish().describe('Filter by platform UUID'),
  property: z.string().describe('Filter by property slug'),
}).describe('Data filter options for description')

export type DescriptionFilter = z.infer<typeof descriptionParamsSchema>

export type Description = {
  id: number
  property_id: number
  name: string
  short_summary: string
  summary: string
  notes: string
  access: string
  transit: string
  interaction: string
  neighbourhood: string
  space: string
  house_manual: string | null
  locale: string
  created_by: string | null
  created_at: string
  updated_by: string | null
  updated_at: string
}

export async function fetchDescription(filter: DescriptionFilter) {
  const url = new URL(`${homerunnerApiBaseUrl()}/public-api/v1/property-descriptions`)
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null) url.searchParams.append(key, String(value))
  })
  const res = await fetch(url.toString())
  await okOrThrow(res, 'Failed to fetch property descriptions')
  const data = await res.json()

  return {
    ...data,
  } as {
    status: 'ok' | 'error'
    result: { descriptions: Description[] }
    status_code: number
  }
}

export function useFetchDescription(filter: DescriptionFilter) {
  return useQuery({
    queryKey: ['description', filter],
    queryFn: () => fetchDescription(filter),
  })
}
